define(function(require){
    'use strict';

    var _ = require('underscore');
    var text = require('i18n!nls/main');

    return {
        t: function(str){
            var args = _.compact(arguments);
            var r, str = args.shift();
        	if(str.indexOf('.') !== -1){
	            var dict = text, path = str.split('.');
	            do{
	            	dict = dict[path.shift()];
	            }while(path.length > 0);
                r = dict;
            }else{
                r = text[str];
            }
            if(Object.prototype.toString.call(r) === '[object Function]'){
                return r.apply(null, args);
            }else{
                return r;
            }
        }
    };
});
